import React, {Component} from "react";

class LinkedSamplePage extends Component{

    render() {
        return(
            <div className="container-fluid">
                外層部のみの銅箔の厚さの選択です、内層の銅厚については17.5μです。

            </div>
        );
    }
}
export default LinkedSamplePage;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/LinkedSamplePage.js